// extracted by mini-css-extract-plugin
module.exports = {"container":"Slider__container--XFZ","overflowSlider":"Slider__overflowSlider--2dn","one":"Slider__one--RN1"};